exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Modal__root___2hNtA{position:fixed;width:100vw;height:100%;min-height:100vh;z-index:10000}.Modal__backdrop___wfW8p,.Modal__root___2hNtA{top:0;left:0;display:flex;justify-content:center;align-items:center}.Modal__backdrop___wfW8p{position:absolute;right:0;bottom:52px;background-color:rgba(43,48,65,.7)}.Modal__modal___2KwxN{border-radius:0;background:#fff;position:relative;box-shadow:0 3px 14px 1px rgba(0,0,0,.2);width:100%;max-width:100%;max-height:100%;padding-bottom:20px;overflow-y:scroll;-webkit-overflow-scrolling:touch}@media (min-width:767px){.Modal__modal___2KwxN{max-width:1400px;width:95%;min-height:95%}}", ""]);

// exports
exports.locals = {
	"root": "Modal__root___2hNtA",
	"backdrop": "Modal__backdrop___wfW8p",
	"modal": "Modal__modal___2KwxN"
};